// How a bid is classified — two separate questions that used to share one dropdown.
//
//   Price Structure  — how the number is built: Lump Sum or Unit Price (hard bids only;
//                      a Time & Material bid's "structure" is its rate block).
//   Work Type        — what kind of work it is. Drives which quote/workflow machinery
//                      the bid flows into (a drilling work type creates the drilling
//                      workflow on award, shows the hole schedule, etc.).
//
// The server keeps the legacy `bid_type` column in step with these (drilling work type
// wins, then T&M, then the price structure), so everything that still reads bid_type —
// award, hole schedule, quote formats — keeps working untouched.
export const PRICE_STRUCTURES = [
  ['lump_sum',   'Lump Sum'],
  ['unit_price', 'Unit Price'],
];

export const WORK_TYPES = [
  ['general',             'General Electrical'],
  ['vertical_drilling',   'Vertical Drilling'],
  ['horizontal_drilling', 'Horizontal Drilling'],
  ['loops',               'Loops'],
];

export const priceStructureLabel = v => (PRICE_STRUCTURES.find(([k]) => k === v) || [])[1] || null;
export const workTypeLabel = v => (WORK_TYPES.find(([k]) => k === v) || [])[1] || null;

// Older rows and older clients may only carry bid_type — read the classification out
// of it so the UI never shows a blank for a bid that clearly is a lump-sum drilling job.
export function classifyBid(bid) {
  if (!bid) return { price_structure: null, work_type: null };
  const bt = bid.bid_type || '';
  const work_type = bid.work_type
    || (bt === 'Vertical Drilling' ? 'vertical_drilling' : bt === 'Directional Drilling' ? 'horizontal_drilling' : 'general');
  const price_structure = bid.price_structure || (bt === 'Unit Price' ? 'unit_price' : 'lump_sum');
  return { price_structure, work_type };
}
export const isDrillingWorkType = wt => wt === 'vertical_drilling' || wt === 'horizontal_drilling';
